module.exports = __webpack_public_path__ + "img/fupa.9ec954cb.png";